var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-grid"},[_c('Tabs',{attrs:{"headers":_vm.tabs.map(v => v.title),"activeTab":_vm.activeTab,"full":false},on:{"change":_vm.setTab}}),_c('div',{staticClass:"tabs"},[_vm._t(_vm.tabs[_vm.activeTab].component)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }